<div style="margin: 24px">
    <p [innerHTML]="privacy | markdown"></p>
</div>
